import React from 'react';
import { Box, Typography } from '@mui/material';
import { DOCUMENT } from '../constants/documentTheme';
import {
  getDefaultItineraryItemImageUrl,
  getItineraryItemImageUrl,
  THUMB_IMAGE_PARAMS,
} from '../utils/itineraryItemImage';
import ItinerarySafeImage from './ItinerarySafeImage';

const plateSx = {
  position: 'absolute',
  inset: 0,
  background: 'radial-gradient(130% 90% at 26% 18%, rgba(201,169,97,0.42) 0%, transparent 60%), linear-gradient(150deg, #5C1620 0%, #2C080E 100%)',
  opacity: 0.28,
  pointerEvents: 'none',
  zIndex: 2,
};

const ItineraryItemThumb = ({
  item,
  pin,
  alt,
  canEdit = false,
  onChangePhoto,
  width = 92,
  params = THUMB_IMAGE_PARAMS,
  aspectRatio = '4 / 3',
}) => {
  const imageUrl = getItineraryItemImageUrl(item, params);

  return (
    <Box
      role={canEdit && onChangePhoto ? 'button' : undefined}
      tabIndex={canEdit && onChangePhoto ? 0 : undefined}
      onClick={(event) => {
        if (!canEdit || !onChangePhoto) return;
        event.stopPropagation();
        onChangePhoto(event);
      }}
      onKeyDown={(event) => {
        if (!canEdit || !onChangePhoto) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          onChangePhoto(event);
        }
      }}
      aria-label={alt}
      data-testid={item?.id != null ? `itinerary-item-thumb-${item.id}` : 'itinerary-item-thumb'}
      sx={{
        position: 'relative',
        width,
        maxWidth: '100%',
        aspectRatio,
        flexShrink: 0,
        overflow: 'hidden',
        bgcolor: DOCUMENT.oxblood,
        cursor: canEdit && onChangePhoto ? 'pointer' : 'default',
      }}
    >
      <ItinerarySafeImage
        src={imageUrl}
        fallbackSrc={getDefaultItineraryItemImageUrl(item, params)}
        alt={alt || ''}
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 1,
          display: 'block',
        }}
      />
      <Box sx={plateSx} />
      {pin != null && (
        <Typography
          component="span"
          sx={{
            position: 'absolute',
            left: 6,
            top: 6,
            zIndex: 3,
            width: 19,
            height: 19,
            bgcolor: '#C9A961',
            color: '#2A070C',
            fontSize: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {pin}
        </Typography>
      )}
    </Box>
  );
};

export default ItineraryItemThumb;
